import { render, staticRenderFns } from "./exp_add.vue?vue&type=template&id=2c88e8bc&scoped=true"
import script from "./exp_add.vue?vue&type=script&lang=js"
export * from "./exp_add.vue?vue&type=script&lang=js"
import style0 from "./exp_add.vue?vue&type=style&index=0&id=2c88e8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c88e8bc",
  null
  
)

export default component.exports